import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Button, message, Card, Checkbox, Select, Spin, Row, Col, Modal, InputNumber } from 'antd';
import * as Icons from '@ant-design/icons';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService'; // Import ApiService class
import eventBus from '../Components/eventBus'; // Import the event bus
import GenericAddRemoveMultipleRecords from '../SetupComponent/GenericAddRemoveMultipleRecordsUI'; // Import the generic component
import CustomDrawer from '../Components/CustomDrawer';

const { Option } = Select;

const CreateObjectDrawer = ({ visible, onClose, onAddOrEditObject, editingRecord }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [isallowSearch, setIsAllowSearch] = useState(false); // State for auto number checkbox
  const [isTrackActivities, setIsTrackActivities] = useState(false); // State for auto number checkbox
  const [isTrackFieldHistory, setIsTrackFieldHistory] = useState(false); // State for auto number checkbox
  const [isAllowFileUpload, setIsAllowFileUpload] = useState(false);
  const [isAllowApprovals, setIsAllowApprovals] = useState(false);
  const [accessPolicies, setAllAccessPolicy] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [formValues, setFormValues] = useState({});
  const [isAllowRoleHierarchy, setIsAllowRoleHierarchy] = useState(false);
  const [isAllowRecordLevelSharing, setIsAllowRecordLevelSharing] = useState(false);
  const [isAllowFeed, setIsAllowFeed] = useState(false);
  const [notificationToFields, setNotificationToFields] = useState(null);




  useEffect(() => {
    if (editingRecord) {
      form.setFieldsValue(editingRecord); // Pre-fill form with existing data if editing
      setInitialValues(editingRecord); // Store initial values
      setIsAllowSearch(editingRecord.allow_search);
      setIsTrackActivities(editingRecord.track_activities);
      setIsTrackFieldHistory(editingRecord.track_field_history);
      setIsAllowFileUpload(editingRecord.allow_files);
      setIsAllowApprovals(editingRecord.allow_approvals);
      setIsAllowRoleHierarchy(editingRecord.allow_role_hierarchy);
      setIsAllowRecordLevelSharing(editingRecord.allow_record_level_sharing);
      setIsAllowFeed(editingRecord.allow_comments);

    } else {
      form.resetFields();
      setInitialValues({});
      setIsAllowSearch(false);
      setIsTrackActivities(false);
      setIsTrackFieldHistory(false);
      setIsAllowFileUpload(false);
      setIsAllowApprovals(false);
      setIsAllowRoleHierarchy(false);
      setIsAllowRecordLevelSharing(false);
      setIsAllowFeed(false);

      setCurrentStep(1);
    }
  }, [visible, editingRecord, form]);

  useEffect(() => {

    const fetchAccessPolicy = async () => {
      try {
        const accessPolicyService = new ApiService(`${BASE_URL}/mt_access_policies`, {}, 'GET');
        const response = await accessPolicyService.makeCall();
        console.log("Access Policy", response);
        setAllAccessPolicy(response);
      } catch (error) {
      }
    }

    if (!editingRecord) {
      fetchAccessPolicy();
    }
  }, []);


  const generateApiName = (label) => {
    return label.replace(/[^a-zA-Z]/g, '').replace(/\s+/g, '').trim();
  };

  const handleLabelChange = (e) => {
    const label = e.target.value;
    const currentName = form.getFieldValue('name');

    if (!currentName) {
      form.setFieldsValue({
        name: generateApiName(label),
      });
    }
  };

  const handleSelectedItems = (value) => {
    setSelectedItems(value);
  }

  useEffect(() => {
  const fetchFields = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_fields/object/${editingRecord.name}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      // ✅ Filter only email or lookup(User) fields
      const fields=
        response.filter(
          (field) =>
            field.type === 'email' ||
            (field.type === 'lookup' && field.parent_object_name === 'User')
        );

        setNotificationToFields(fields);
      
    } catch (error) {
    }
  };

  if (editingRecord) {
    fetchFields();
  }
}, [editingRecord?._id]);

  const handleFinish = async (values, saveAndNew = false) => {
    setLoading(true); // Start the spinner

    if (!values) {
      return;
    }
    // Create a payload with only the changed fields
    const formData = {};
    for (const key in values) {
      if (values[key] !== initialValues[key]) {
        formData[key] = values[key];
      }
    }

    if (isallowSearch !== initialValues.allow_search) {
      formData.allow_search = isallowSearch;
    }
    if (isTrackActivities !== initialValues.track_activities) {
      formData.track_activities = isTrackActivities;
    }
    if (isTrackFieldHistory !== initialValues.track_field_history) {
      formData.track_field_history = isTrackFieldHistory;
    }
    if (isAllowFileUpload !== initialValues.allow_files) {
      formData.allow_files = isAllowFileUpload;
    }
    if (isAllowApprovals !== initialValues.allow_approvals) {
      formData.allow_approvals = isAllowApprovals;
    }
    if (isAllowRoleHierarchy !== initialValues.allow_role_hierarchy) {
      formData.allow_role_hierarchy = isAllowRoleHierarchy;
    }
    if (isAllowRecordLevelSharing !== initialValues.allow_record_level_sharing) {
      formData.allow_record_level_sharing = isAllowRecordLevelSharing;
    }
    if (isAllowFeed !== initialValues.allow_comments) {
      formData.allow_comments = isAllowFeed;
    }

    console.log("Form Data", formData);


    try {
      let response;
      if (editingRecord && editingRecord.key) {
        if (Object.keys(formData).length === 0) {
          message.warning('No changes made.');
          onAddOrEditObject({ ...editingRecord, ...formData }); // Update the object in the parent component
          return;
        }
        const apiService = new ApiService(
          `${BASE_URL}/mt_objects/${editingRecord.key}`,
          { 'Content-Type': 'application/json' },
          'PUT',
          { mt_object: formData }
        );
        response = await apiService.makeCall();
        message.success('Object updated successfully');

        onAddOrEditObject({ ...editingRecord, ...formData }); // Update the object in the parent component

        // Handle newTab creation if addObjectTab is true
        // if (formData.addObjectTab) {
        //   const newTab = {
        //     label: values.label,
        //     name: values.name,
        //     description: 'All Accounts',
        //     mt_object_id: editingRecord.key, // Use the existing object ID
        //     icon: values.icon,
        //     addObjectTab: values.addObjectTab,
        //     order: values.order,
        //     active:true,
        //   };
        //   console.log('newTab', newTab);
        //   if (newTab.icon && newTab.addObjectTab) {
        //     const apiServiceForTab = new ApiService(
        //       `${BASE_URL}/mt_tabs`,
        //       { 'Content-Type': 'application/json' },
        //       'POST',
        //       { mt_tab: newTab }
        //     );
        //     const tabResponse = await apiServiceForTab.makeCall();
        //     if (!tabResponse || !tabResponse._id) {
        //       throw new Error('Failed to create a new tab');
        //     }
        //   }
        // }
      } else {
        // Create new record using ApiService
        const apiService = new ApiService(
          `${BASE_URL}/mt_objects`,
          { 'Content-Type': 'application/json' },
          'POST',
          {
            mt_object: {
              ...formData,
            },
            access_params: { "policy_ids": selectedItems }
          }
        );
        response = await apiService.makeCall();
        if (response && response._id) {
          message.success('Object created successfully');
        } else {
          throw new Error('Invalid response from server');
        }
        const newTab = {
          label: values.label,
          name: values.name,
          description: 'All Accounts',
          mt_object_id: response._id, // Use the new object ID from the response
          icon: values.icon,
          addObjectTab: values.addObjectTab,
          order: values.order,
          active: true,
          tab_category:"object"
        };
        if (newTab.icon && newTab.addObjectTab) {
          const apiServiceForTab = new ApiService(
            `${BASE_URL}/mt_tabs`,
            { 'Content-Type': 'application/json' },
            'POST',
            { mt_tab: newTab }
          );
          const tabResponse = await apiServiceForTab.makeCall();
          if (!tabResponse || !tabResponse._id) {
            throw new Error('Failed to create a new tab');
          }
        }
        // Update the list of objects in the parent component
        onAddOrEditObject({
          key: response._id, // Use the ID from the response
          ...formData
        });
      }
      // eventBus.emit('objectCreatedOrUpdated');
      if (!saveAndNew) {
        onClose(); // Close the drawer for regular save
        form.resetFields();
        setSelectedItems([]); // Reset selected items
      } else {
        form.resetFields(); // Reset the form for new object creation
        setSelectedItems([]); // Reset selected items

      }
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save object due to an unknown error';
      message.error(errorMessage);
    } finally {
      setLoading(false); // Stop the spinner
    }
  };

  const iconOptions = Object.keys(Icons)
    .filter((iconName) => iconName[0] >= 'A' && iconName[0] <= 'T')
    .map((iconName) => {
      const IconComponent = Icons[iconName];
      return (
        <Option key={iconName} value={iconName} label={iconName}>
          <span>
            {React.createElement(IconComponent, null)}
            <span style={{ marginLeft: 8 }}>{iconName}</span>
          </span>
        </Option>
      );
    });

  const isEditingSystemRecord = editingRecord && editingRecord.is_system;

  return (
    <CustomDrawer
      title={editingRecord ? 'Edit Object' : 'Create New Object'}
      visible={visible}
      zIndex={1002}   // higher than sidebar
      onClose={!loading ? onClose : null}
      closable={false}



      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
          <Button onClick={onClose} disabled={loading}>Cancel</Button>
          <div>
            {!editingRecord && currentStep === 2 && (
              <Button onClick={() => setCurrentStep(1)} disabled={loading} style={{ marginRight: '5px' }}>Prev</Button>
            )}
            {!editingRecord && currentStep === 1 && (
              <Button type="primary"
                disabled={loading}
                onClick={() => {
                  console.log("Form values", form.getFieldsValue());
                  setFormValues(form.getFieldsValue());
                  form.validateFields().then(() => setCurrentStep(2))
                }}>
                Next
              </Button>
            )}
            {(editingRecord || currentStep === 2) && (
              <>
                {!editingRecord && (
                  <Button style={{ marginRight: '8px' }}
                    disabled={loading}
                    onClick={() => {
                      form.validateFields().then((values) => {
                        handleFinish(values, true); // Pass a flag to differentiate Save & New
                      });
                    }}>
                    Save & New
                  </Button>
                )}
                <Button type="primary"
                  disabled={loading}
                  onClick={() => {
                    form.validateFields().then(() => handleFinish(editingRecord ? form.getFieldsValue() : formValues), false);
                  }}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      }>
      <Spin spinning={loading} tip="Loading...">
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          onFinish={handleFinish}
        >
          {currentStep === 1 && (
            <>
              <Form.Item
                name="label"
                label="Label"
                rules={[{ required: true, message: 'Please enter the label' }]}
              >
                <Input placeholder="Please enter the field label" onBlur={handleLabelChange} />
              </Form.Item>
              <Form.Item
                name="name"
                label="API Name"
                rules={[
                  { required: true, message: 'Please enter the name' },
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.resolve();
                      }

                      // Check if the value contains only alphabets without spaces
                      if (!/^[a-zA-Z]+$/.test(value)) {
                        return Promise.reject(new Error('Name should only contain alphabets without spaces.'));
                      }

                      // Check if the first letter is capitalized
                      if (!/^[A-Z]/.test(value)) {
                        return Promise.reject(new Error('Name should start with a capital letter.'));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Please enter the name" disabled={!!editingRecord} />
              </Form.Item>
              <Form.Item
                name="pluralLabel"
                label="Plural Label"
                rules={[{ required: true, message: 'Please enter the plural label' }]}
              >
                <Input placeholder="Please enter the plural label" disabled={isEditingSystemRecord} />
              </Form.Item>

              <Form.Item
                name="description"
                label="Object Description"
              >
                <Input placeholder="Please enter the object description" disabled={isEditingSystemRecord} />
              </Form.Item>

              <Form.Item name="record_creation_view" label="Record Creation View">
                <Select allowClear placeholder="Select a view" >
                  <Option value="Drawer">Drawer</Option>
                  <Option value="Modal">Modal</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="default_access"
                label="Default Access"
                initialValue="public_read_write"
                rules={[{ required: true, message: 'Please select object permissions' }]}
              >
                <Select placeholder="Select object record access">
                  <Option value="private"> Private (Only owner access)</Option>
                  <Option value="public_read">Public Read</Option>
                  <Option value="public_read_write">Public Read/Write</Option>
                </Select>
              </Form.Item>


            {editingRecord && (
                
                  <Form.Item label="Notification To" name="notification_to">
                    <Select allowClear placeholder="Select notification to" optionLabelProp="label" >
                      {notificationToFields?.map((nf) => (
                            <Option key={nf.name} value={nf.name}>
                              {nf.label}
                            </Option>
                          ))}
                    </Select>

                  </Form.Item>
            )}



              {!editingRecord && (
                <>
                  <Form.Item name="icon" label="Icon">
                    <Select allowClear placeholder="Select an icon" optionLabelProp="label" showSearch filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    } disabled={isEditingSystemRecord}>
                      {iconOptions}
                    </Select>

                  </Form.Item>



                  <Form.Item name="addObjectTab" valuePropName="checked">
                    <Checkbox disabled={isEditingSystemRecord}>Add Object Tab</Checkbox>
                  </Form.Item>
                </>
              )}


              <Form.Item name="allow_role_hierarchy" >
                <Checkbox
                  checked={isAllowRoleHierarchy}
                  onChange={(e) => setIsAllowRoleHierarchy(e.target.checked)}
                >Allow role heirarchy</Checkbox>
              </Form.Item>

              <Form.Item name="allow_record_level_sharing" >
                <Checkbox
                  checked={isAllowRecordLevelSharing}
                  onChange={(e) => setIsAllowRecordLevelSharing(e.target.checked)}
                >Allow record level sharing</Checkbox>
              </Form.Item>

              <Form.Item name="allowSearch" >
                <Checkbox
                  checked={isallowSearch}
                  onChange={(e) => setIsAllowSearch(e.target.checked)}
                >Allow Search</Checkbox>
              </Form.Item>
              <Form.Item name="trackActivities"
              >
                <Checkbox
                  checked={isTrackActivities}
                  onChange={(e) => setIsTrackActivities(e.target.checked)}
                >Track Activities</Checkbox>
              </Form.Item>
              <Form.Item name="trackFieldHistory">
                <Checkbox
                  checked={isTrackFieldHistory}
                  onChange={(e) => setIsTrackFieldHistory(e.target.checked)}
                >Track Field History</Checkbox>
              </Form.Item>

              <Form.Item name="allowFileUpload">
                <Checkbox
                  checked={isAllowFileUpload}
                  onChange={(e) => setIsAllowFileUpload(e.target.checked)}
                >Allow File Upload</Checkbox>
              </Form.Item>

              <Form.Item name="allowApprovals">
                <Checkbox
                  checked={isAllowApprovals}
                  onChange={(e) => setIsAllowApprovals(e.target.checked)}
                >Allow Approvals</Checkbox>
              </Form.Item>

              <Form.Item name="allowComments">
                <Checkbox
                  checked={isAllowFeed}
                  onChange={(e) => setIsAllowFeed(e.target.checked)}
                >Allow Feed</Checkbox>
              </Form.Item>




              {!editingRecord && (

                <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.addObjectTab !== currentValues.addObjectTab}>
                  {({ getFieldValue }) =>
                    getFieldValue('addObjectTab') ? (
                      <Form.Item
                        name="order"
                        label="Tab Order"
                        rules={[{ required: true, message: 'Please enter the tab order' }]}
                      >
                        <InputNumber
                          placeholder="Please enter the tab order"
                          disabled={isEditingSystemRecord}
                          min={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    ) : null
                  }
                </Form.Item>
              )}

            </>
          )}
        </Form>

        {!editingRecord && currentStep === 2 && (
          <GenericAddRemoveMultipleRecords
            titleLeft="Available Access Policies"
            titleRight="Selected Access Policies"
            dataSource={accessPolicies}
            selectedKeys={selectedItems}
            onUpdateSelectedKeys={setSelectedItems}
            columnsLeft={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
            columnsRight={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
            searchFields={['Name']}
          />
        )}
      </Spin>
    </CustomDrawer>
  );
};

export default CreateObjectDrawer;